import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems } from '../data/transformation';
export function ComparisonSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-36" data-mp="39dpm8awihhcj">
      <Reveal className="mx-auto max-w-5xl" data-id="element-37" data-mp="34fo4btatno2n">
        <div className="mx-auto mb-12 max-w-3xl text-center" data-id="element-38" data-mp="34emozcmrwff4">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-39" data-mp="2zgbj1czlmp26">IL COSTO DI PARTIRE DA ZERO</p>
          <h2 className="text-3xl font-extrabold leading-[1.1] tracking-tight text-brand-blue md:text-4xl" data-id="element-40" data-mp="2veq9a0id2qw7">
            Ogni Lezione da Improvvisare, o Ogni Unità Già Pronta.
          </h2>
        </div>
        <div className="overflow-hidden rounded-3xl border border-brand-dark bg-brand-alt shadow-[0_18px_45px_rgba(29,92,158,0.10)]" data-id="element-41" data-mp="2lhlni1sfgxfx">
          <div className="grid md:grid-cols-2" data-id="element-42" data-mp="onqsp6g7ratg">
            <Comparison title="PRIMA" items={beforeItems} positive={false} data-id="element-43" data-mp="joxf7e0xfjta" />
            <Comparison title="CON ARTE PRONTA" items={afterItems} positive data-id="element-44" data-mp="3af4d2dy6tnhy" />
          </div>
          <div className="border-t border-brand-dark bg-brand-main px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-45" data-mp="3ahh37ee3n463">
            Un sistema artistico completo: prepari meno e insegni con più sicurezza.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-dark bg-brand-alt md:border-l md:border-t-0' : 'bg-brand-main'}`} data-id="element-46" data-mp="1y9lhumubpj6">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-47" data-mp="3jdygoo9xre50">
        <div data-id="element-48" data-mp="3odb2d5p2mf60">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-green' : 'text-brand-gray'}`} data-id="element-49" data-mp="3od19998qbrw3">
            {positive ? 'IL CURRICOLO PRONTO ALL’USO' : 'IL VECCHIO MODO DI INSEGNARE ARTE'}
          </p>
          <h3 className="mt-2 font-display text-2xl font-bold tracking-tight text-brand-blue" data-id="element-50" data-mp="um17gac01f10">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-green text-white shadow-md' : 'bg-brand-alt text-brand-gray'}`} data-id="element-51" data-mp="pnznln6r1boh">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-52" data-mp="gl8aliy867uq" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-53" data-mp="bn6p6rdbtwg3">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-main' : 'bg-brand-alt/70'}`} data-id="element-54" data-mp="6w6w5x7bvyiv">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-green' : 'text-brand-gray'}`} aria-hidden="true" data-id="element-55" data-mp="1xdjg6zv8bjr" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-56" data-mp="3p0rxm08ayu1c">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}